module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av512-ea79323eb0ef71f9932b772e216b4aa6.jpg";